import { useCallback, useState } from 'react';

interface SearchTermStateReturn {
  searchTerm: string;
  resetSearchTerm: () => void;
  handleSearchChange: (value: string) => void;
}

/**
 * Hook that manages search term state with change and reset handlers
 * @returns Object containing search term state and handlers
 */
export const useSearchTermState = (): SearchTermStateReturn => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSearchChange = useCallback((value: string): void => {
    setSearchTerm(value);
  }, []);

  const resetSearchTerm = useCallback((): void => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    resetSearchTerm,
    handleSearchChange,
  };
};
